<template>
  <main class="bg-white py-10">
    <!-- Section for 7 Perfect Quotes -->
    <div class="md:px-12 max-w-screen-2xl mx-auto px-4">
      <!-- Header -->
      <div class="flex items-center justify-center">
        <div class="text-center">
          <div class="flex items-center justify-center">
            <h2 class="text-lg text-black font-semibold -mb-7">
              Hi! Here are my top 7 perfect quotes.
            </h2>
          </div>
        </div>
      </div>

      <!-- Slider for Designs -->
      <div class="md:px-10 max-w-screen-2xl mx-auto py-8">
        <div id="default-carousel" class="relative" data-carousel="slide">
          <!-- Carousel wrapper -->
          <div class="relative overflow-hidden rounded-lg lg:py-10" data-carousel-item>
            <!-- Carousel container -->
            <div
              class="flex gap-6 transition-transform duration-700 ease-in-out"
              :style="{
                transform: `translateX(-${
                  activeIndex * (100 / cardsPerSlide)
                }%)`,
              }"
            >
              <!-- Design Cards (converted to slider) -->
              <div
                v-for="(design, index) in designs"
                :key="design.id"
                class="relative w-full sm:w-1/2 md:w-1/3 lg:w-1/4 min-w-[80%] sm:min-w-[50%] md:min-w-[33.33%] lg:min-w-[30%] cursor-pointer text-center py-4 px-4 rounded-lg shadow-lg transition-all duration-500 hover:scale-105 hover:shadow-xl"
              >
                <!-- Background image with overlay -->
                <div
                  class="relative h-72 w-full bg-cover bg-center rounded-md overflow-hidden"
                  :style="{ backgroundImage: `url(${design.image})` }"
                >
                  <!-- Overlay -->
                  <div class="absolute inset-0 bg-black bg-opacity-50"></div>

                  <!-- Text content -->
                  <div
                    class="absolute inset-0 flex flex-col items-center justify-center px-4 text-white mt-6"
                  >
                  <p class="text-center text-sm mb-3">{{ design.description }}</p>
                    <h3 class="text-xl font-bold">~ {{ design.name }}</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: 0,
      cardsPerSlide: 3, // Adjust according to the number of cards per slide (3 cards in this case)
      designs: [
        {
          id: 1,
          name: "B.U Mshelia",
          description:
            "Your first investment in property doesn't need to be perfect, focus more on learning the rules of the game. Real Estate is a chessboard, not a game of chance.",
          image: require("../assets/images/brand.jpeg"),
        },
        {
          id: 2,
          name: "B.U Mshelia",
          description:
            "A team built on integrity is unstoppable in Real Estate. When every member acts with honesty and unites around common goals, it not only strengthens client trust but also creates a foundation for long term success.",
          image: require("../assets/images/brand.jpeg"),
        },
        {
          id: 3,
          name: "B.U Mshelia",
          description: "When people reach out to you in Real Estate, they're counting on you to help them make smart, valuable decisions.",
          image: require("../assets/images/brand.jpeg"),
        },
        {
          id: 4,
          name: "B.U Mshelia",
          description: "True success in Real Estate isn't found in property, but in purpose.",
          image: require("../assets/images/brand.jpeg"),
        },
        {
          id: 5,
          name: "B.U Mshelia",
          description: "Fear is a choice progress is a commitment.",
          image: require("../assets/images/brand.jpeg"),
        },
        {
          id: 6,
          name: "B.U Mshelia",
          description: "Life isn't a race to the finish line; it's a journey of planting seeds. Some will bloom quickly, others in their own season. Your job is to nurture every moment with faith and patience, knowing each step matters.",
          image: require("../assets/images/brand.jpeg"),
        },
        {
          id: 7,
          name: "B.U Mshelia",
          description: "Fear is a choice progress is a commitment.",
          image: require("../assets/images/brand.jpeg"),
        },
      ],
      slideInterval: null, // To store interval for automatic sliding
    };
  },
  mounted() {
    // Set up automatic slide change every 3 seconds
    this.slideInterval = setInterval(this.nextSlide, 3000);
  },
  beforeDestroy() {
    // Clear the interval when the component is destroyed
    clearInterval(this.slideInterval);
  },
  methods: {
    nextSlide() {
  const maxIndex = Math.ceil(this.designs.length / this.cardsPerSlide) - 1;
  if (this.activeIndex < maxIndex) {
    this.activeIndex++;
  } else {
    this.activeIndex = 0; // Reset to the first slide
  }
},
    prevSlide() {
      if (this.activeIndex > 0) {
        this.activeIndex--;
      } else {
        this.activeIndex =
          Math.ceil(this.designs.length / this.cardsPerSlide) - 1; // Go to the last set of slides
      }
    },
  },
};
</script>

<style scoped>
/* Custom styling */
.carousel-wrapper {
  display: flex;
  gap: 6px;
  transition: transform 0.5s ease-in-out;
}

img {
  transition: transform 0.3s ease-in-out;
}

img:hover {
  transform: scale(1.05);
}
</style>
